// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useNotify } from "react-admin";
import * as React from "react";
import { Card, TextField,Button,Switch
} from '@material-ui/core';
import {edit_diet_type_form} from './index'
import { useForm,Controller } from "react-hook-form";
// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
    const regex = /^09\d{9}$/;
    if (value) {
      if (!regex.test(value)) {
        return "شماره موبایل صحیح نمیباشد";
      }
      return true;
    }
  };
export function EditDietType({ resetKey }) {
    interface IFormInput {
        mobile: string;
        newDietType: string;
        canChangeSubmittedDiet:boolean;
      }
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid, },
      } = useForm<IFormInput>({
        mode: "onChange",
        defaultValues: {
            mobile: null,
            newDietType: null,
            canChangeSubmittedDiet:false
        },
      });
    const notify = useNotify()
      const [errorMessages, setErrorMessages] = React.useState([]);
      const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
      const onSubmit = async (data: IFormInput) => {
        setErrorMessages([]);
        setNetworkState("PENDING");
        const postData = {
            mobile: data.mobile,
            newDietType: data.newDietType,
            canChangeSubmittedDiet:data.canChangeSubmittedDiet
        };
    
        edit_diet_type_form(postData).then((res)=>{
            if (res.data && res.data.err) {
                setErrorMessages([res.data.err.details.messages[0]]); 
                setNetworkState("FAILED");
            }   else{
              if (res.data && res.data.status === "SUCCESS") {
                notify("     تغییر رژیم با موفقیت انجام شد", { type: 'success' })    
                resetKey(Date.now());
            } 
            }  
          }).catch((err)=>{
            console.log('err',err);            
          })
          
        }
   const dietList = [{label:'رژیم معمولی',value:'NORMAL'},{label:'رژیم مزوبولیک',value:'PREMIUM'}]
    return (
        <Card style={{margin:"1rem"}}>
           <h3 style={{fontFamily: 'IranSans-Medium',color:'rgb(71 68 68 / 87%)',marginRight:'3rem'}}>   تغییر رژیم </h3>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          margin:"3rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("mobile", {
            required: "شماره موبایل  را وارد نمایید"
          })}
          error={!!errors.mobile}
          helperText={errors.mobile ? errors.mobile.message : null}
          fullWidth
          label="شماره موبایل "
          variant="outlined"
        />


     
                    <TextField
                        {...register("newDietType", {
                            
                        })}
                        error={!!errors.newDietType}
                        helperText={errors.newDietType ? errors.newDietType.message : null}
                        fullWidth
                        label="نوع رژیم"
                        size="medium"
                        id="outlined-select-currency-native"
                        select
                     
                        variant="outlined"
                        
                    >
                        {dietList.map((option) => (
                            <option style={{cursor:"pointer", padding:"6px",backgroundColor:"Menu"}} key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </TextField>
                    <div style={{ display: 'flex', justifyContent: 'end', width: '100%', alignItems: 'center' }}>
       <Controller
        name="canChangeSubmittedDiet"
        control={control}
        render={({field: { ref, ...field } }) =>
        <><Switch
            {...field}
            inputRef={ref}
            color="primary"
            name="canChangeSubmittedDiet"
            inputProps={{ 'aria-label': 'secondary checkbox' }} /><p style={{ fontFamily: 'IranSans-Bold', fontSize: '11px' }}>تغییر نوع رژیم در صورت ثبت در سیب دایت </p></>
      }
      />
       </div>
        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
      ثبت
        </Button>

        {networkState === "SUCCESS" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ?   <p style={{color:'red'}}>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div> )}
      </form>
   
        </Card >
    )
}